/* eslint-disable indent */
import Form from 'react-bootstrap/Form'
import { getTranslation } from '../services/translations'
import { decodeHtmlEntities } from '../services/helpfunctions'

const TeamVisibilityManager = ({
  user,
  handleTeamToggle,
  handleHideTrainingDataToggle,
  lang = 'fi',
}) => {
  const t = key => getTranslation(lang, key)

  // Näytä vain jos käyttäjällä on joukkueita
  if (!user || !user.teams || user.teams.length === 0) {
    return null
  }

  return (
    <div style={{ marginBottom: '20px' }}>
      <h5>{t('myTeams')}</h5>
      <p className="text-muted mb-2">{t('teamVisibilityInfo')}</p>
      {user.teams.map((team, index) => {
        // Tarkistetaan onko joukkue objekti vai ID-numero
        const isObjectFormat = typeof team === 'object'
        const teamID = isObjectFormat ? team.teamID : team
        const isPublic = isObjectFormat ? team.public !== false : true
        const hideTrainingData = isObjectFormat && team.hideTrainingData === true
        const teamName = isObjectFormat
          ? decodeHtmlEntities(team.teamName)
          : `Team ${teamID}`

        return (
          <div
            key={index}
            style={{
              marginBottom: '10px',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <span style={{ marginRight: '10px' }}>{teamName}</span>
              <Form.Check
                type="switch"
                id={`custom-switch-${teamID}`}
                checked={isPublic}
                onChange={() => handleTeamToggle(teamID, isPublic)}
                label={isPublic ? t('public') : t('private')}
                style={{ color: isPublic ? 'green' : 'red' }}
              />
            </div>
            {!isPublic && (
              <Form.Check
                type="switch"
                id={`hide-training-data-switch-${teamID}`}
                checked={hideTrainingData}
                onChange={() =>
                  handleHideTrainingDataToggle(teamID, hideTrainingData)
                }
                label={t('hideTrainingData')}
                style={{ marginTop: '5px' }}
              />
            )}
          </div>
        )
      })}
    </div>
  )
}

export default TeamVisibilityManager
